import React from 'react';
import { motion } from 'framer-motion';

const StatsCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  trendValue, 
  color = 'blue',
  delay = 0 
}) => {
  const colorClasses = {
    blue: 'from-blue-500 to-cyan-500',
    green: 'from-emerald-500 to-green-500',
    amber: 'from-amber-500 to-orange-500',
    purple: 'from-purple-500 to-pink-500',
    red: 'from-red-500 to-rose-500',
  };

  const iconColorClasses = {
    blue: 'bg-blue-100 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400',
    green: 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/20 dark:text-emerald-400',
    amber: 'bg-amber-100 text-amber-600 dark:bg-amber-900/20 dark:text-amber-400',
    purple: 'bg-purple-100 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400',
    red: 'bg-red-100 text-red-600 dark:bg-red-900/20 dark:text-red-400',
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5 }}
      className="relative overflow-hidden rounded-xl bg-white dark:bg-gray-800 shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-shadow duration-300"
    >
      {/* Background gradient */}
      <div className={`absolute -top-6 -right-6 h-20 w-20 lg:h-32 lg:w-32 lg:-top-10 lg:-right-10 bg-gradient-to-br ${colorClasses[color]} opacity-10 rounded-full`} />
      
      <div className="p-4 lg:p-6 relative">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-xs lg:text-sm text-gray-600 dark:text-gray-400 font-medium">
              {title}
            </p>
            <p className="text-xl lg:text-3xl font-bold text-gray-900 dark:text-white mt-1 lg:mt-2">
              {value}
            </p>
            
            {trend && trendValue && (
              <div className="flex items-center mt-1 lg:mt-2">
                <span className={`text-sm font-medium ${
                  trend === 'up' ? 'text-green-600' : 
                  trend === 'down' ? 'text-red-600' : 'text-gray-600'
                }`}>
                  {trend === 'up' ? '↗' : trend === 'down' ? '↘' : '→'} {trendValue}
                </span>
                <span className="text-xs text-gray-500 ml-1">vs last period</span>
              </div>
            )}
          </div>
          
          {Icon && (
            <div className={`h-10 w-10 lg:h-12 lg:w-12 rounded-lg ${iconColorClasses[color]} flex items-center justify-center flex-shrink-0`}>
              <Icon className="h-5 w-5 lg:h-6 lg:w-6" />
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default StatsCard;